var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamcompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 93,
    viewBox: "0 0 150 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.786 36.7468C101.786 45.4742 108.865 52.5556 117.589 52.5556C126.314 52.5556 133.393 45.4742 133.393 36.7468C133.393 28.0194 126.314 20.938 117.589 20.938C108.865 20.9763 101.786 28.0194 101.786 36.7468Z",
    fill: "#FCFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6071 36.7468C16.6071 45.4742 23.6862 52.5556 32.4107 52.5556C41.1352 52.5556 48.2143 45.4742 48.2143 36.7468C48.2143 28.0194 41.1352 20.938 32.4107 20.938C23.6862 20.9763 16.6071 28.0194 16.6071 36.7468Z",
    fill: "#FCFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4949 32.23C53.4949 44.1345 63.1378 53.7423 75 53.7423C86.9005 53.7423 96.5051 44.0962 96.5051 32.23C96.5051 20.3638 86.8622 10.7178 75 10.7178C63.0995 10.7178 53.4949 20.3638 53.4949 32.23Z",
    fill: "#FCFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5255 55.8093C51.352 55.8093 42.3214 64.8812 42.3214 76.0584V85.8576H107.679V76.0584C107.679 64.8812 98.6097 55.8093 87.4362 55.8093H62.5255ZM82.9974 82.3743H80.0128H69.949H66.9643L62.3342 57.9912C62.7934 57.9529 63.2525 57.9146 63.7117 57.9146H86.25C86.7092 57.9146 87.1684 57.9529 87.6275 57.9912L82.9974 82.3743Z",
    fill: "#FCFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5255 65.9912L80.0128 82.3742H82.9974L87.6276 57.9911C87.1684 57.9528 86.7092 57.9146 86.25 57.9146H63.7117C63.2526 57.9146 62.7934 57.9528 62.3342 57.9911L66.9643 82.3742H69.949L72.4362 65.9912H72.5128L70.0638 61.4744H79.8597L77.4107 65.9912H77.5255Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5561 54.0486H23.2653C15.0765 54.0486 8.41837 60.709 8.41837 68.9005V76.0967H39.9107C40.0638 68.1349 44.3495 61.1683 50.6633 57.2257C48.176 55.2352 45 54.0486 41.5561 54.0486ZM38.3036 73.5704H36.1224H28.699H26.5179L23.1122 55.6945L24.1071 55.6563H40.676L41.6709 55.6945L38.3036 73.5704Z",
    fill: "#FCFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.735 54.0486H108.444C105 54.0486 101.824 55.2352 99.3367 57.1874C105.689 61.13 109.974 68.0966 110.128 76.0967H141.582V68.9005C141.582 60.709 134.923 54.0486 126.735 54.0486ZM123.482 73.5704H123.367H121.301H113.916H111.735H111.62L108.214 55.6945H108.329L109.324 55.6563H125.893C126.237 55.6563 126.582 55.6945 126.888 55.6945L123.482 73.5704Z",
    fill: "#FCFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamcompany);
export default __webpack_public_path__ + "static/media/teamcompany.2b0263e60b56829d039a73eed126d6a3.svg";
export { ForwardRef as ReactComponent };